import React from 'react';
import SettingsModal from './SettingsModal';
import '../style/css/settingspage.css';

/*
 * SettingsPage — the settings area as a full in-app SECTION (reached from the side nav),
 * instead of a popup modal. Reuses the existing SettingsModal panels + sub-menu; the
 * `.settings-page` wrapper reframes it as a page on the gray app canvas.
 */
export default function SettingsPage(props) {
    return (
        <div className="settings-page">
            <div className="settings-page-inner">
                <SettingsModal onUpdate={props.onUpdate} />
            </div>
        </div>
    );
}
